// Mirrors src/constants/commerceEventTypes.ts in pi_ecommerce_api -- kept in
// sync manually since these are separate repos/deployments.
export const COMMERCE_EVENT_TYPES = [
	'order.created',
	'order.pending_approval',
	'order.approved',
	'order.rejected',
	'order.shipped',
	'order.exception',
	'order.exception_resolved',
	'order.delayed',
	'payment.authorized',
	'payment.failed',
	'inventory.low',
	'inventory.updated',
	'customer.created',
	'customer.updated',
	'customer.reorder_due',
	'product.created',
	'product.updated',
	'workflow.started',
	'workflow.step_started',
	'workflow.step_completed',
	'workflow.waiting',
	'workflow.resumed',
	'workflow.failed',
	'workflow.completed',
	'workflow.cancelled',
	'approval.requested',
	'approval.completed',
	'approval.expired',
];

// Human-readable labels for a single-entity timeline (OrderTimeline.js and
// any future ProductTimeline/CustomerTimeline reuse). Falls back to a
// humanized version of the raw eventType for anything not listed here, so a
// new event type added to the taxonomy above never renders blank.
export const COMMERCE_EVENT_LABELS = {
	'order.created': 'Order created',
	'order.pending_approval': 'Approval requested',
	'order.approved': 'Order approved',
	'order.rejected': 'Order rejected',
	'order.shipped': 'Shipment created',
	'order.exception': 'Order exception',
	'order.exception_resolved': 'Exception resolved',
	'order.delayed': 'Order delayed',
	'payment.authorized': 'Payment authorized',
	'payment.failed': 'Payment failed',
	'inventory.low': 'Inventory low',
	'inventory.updated': 'Inventory updated',
	'customer.created': 'Customer created',
	'customer.updated': 'Customer updated',
	'customer.reorder_due': 'Reorder due',
	'product.created': 'Product created',
	'product.updated': 'Product updated',
	'workflow.started': 'Workflow started',
	'workflow.step_started': 'Step started',
	'workflow.step_completed': 'Step completed',
	'workflow.waiting': 'Waiting',
	'workflow.resumed': 'Resumed',
	'workflow.failed': 'Workflow failed',
	'workflow.completed': 'Workflow completed',
	'workflow.cancelled': 'Workflow cancelled',
	'approval.requested': 'Approval requested',
	'approval.completed': 'Approval decided',
	'approval.expired': 'Approval expired',
};

// Longer explanations for surfaces with room for them (Notification Rules
// tab's event picker/table) -- COMMERCE_EVENT_LABELS stays short for the
// single-entity timeline this was originally built for.
export const COMMERCE_EVENT_DESCRIPTIONS = {
	'order.created': 'A new order was placed.',
	'order.pending_approval': 'An order needs approval before it can proceed.',
	'order.approved': 'An approver approved an order.',
	'order.rejected': 'An approver rejected an order.',
	'order.shipped': 'An order has shipped.',
	'order.exception': 'An order hit a problem that needs attention (e.g. failed ERP submission).',
	'order.exception_resolved': "A previously flagged order exception was resolved.",
	'order.delayed': "An order hasn't shipped within the expected timeframe.",
	'payment.authorized': 'A loyalty-points payment was successfully authorized.',
	'payment.failed': 'A loyalty-points payment was denied or failed.',
	'inventory.low': "A product's stock fell below its safety threshold.",
	'inventory.updated': "A product's available inventory quantity changed.",
	'customer.created': 'A new customer account was created.',
	'customer.updated': "A customer's account details were updated.",
	'customer.reorder_due': 'A customer is due for a reorder based on their purchase history.',
	'product.created': 'A new product was added to the catalog.',
	'product.updated': "A product's details were updated.",
};

export const humanizeEventType = (eventType) =>
	COMMERCE_EVENT_LABELS[eventType] ||
	String(eventType || '')
		.split('.')
		.pop()
		.replace(/_/g, ' ')
		.replace(/^./, (c) => c.toUpperCase());
